import { SectionReveal, StaggerReveal, StaggerItem } from "~/components/company/SectionReveal"

const steps = [
  {
    num: "01",
    title: "Discovery Call",
    description: "We learn about your business, goals, and constraints. 30-minute conversation, no pitch."
  },
  {
    num: "02",
    title: "Proposal & Planning",
    description: "We outline the scope, timeline, and investment. You get a clear roadmap before we start."
  },
  {
    num: "03",
    title: "Build & Demo",
    description: "We work in 1-week sprints. You see progress every week with live demos and feedback loops."
  },
  {
    num: "04",
    title: "Launch & Iterate",
    description: "Product goes live. We support initial launch, gather user feedback, and ship v2 improvements."
  }
]

export function ProcessSection() {
  return (
    <section className="w-full bg-white py-16 md:py-20 lg:py-24">
      <div className="container px-4 md:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto space-y-16">
          <SectionReveal className="space-y-4 text-center">
            <p className="text-[#ed2132] font-semibold">HOW IT WORKS</p>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900">
              Simple, Predictable Process
            </h2>
          </SectionReveal>

          <StaggerReveal className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" staggerDelay={0.12}>
            {steps.map((step, index) => (
              <StaggerItem key={index}>
                <div className="flex flex-col h-full">
                  <div className="bg-red-50 border border-red-200 rounded-lg p-6 flex-1 space-y-4 hover:shadow-lg hover:border-red-300 transition-all duration-300">
                    <div className="space-y-2">
                      <p className="text-[#ed2132] text-sm font-bold">STEP {step.num}</p>
                      <h3 className="text-xl font-bold text-slate-900">{step.title}</h3>
                    </div>
                    <p className="text-slate-600 text-sm">{step.description}</p>
                  </div>
                  {index < steps.length - 1 && (
                    <div className="hidden lg:flex items-center justify-center h-12">
                      <div className="w-0.5 h-8 bg-slate-200" />
                    </div>
                  )}
                </div>
              </StaggerItem>
            ))}
          </StaggerReveal>
        </div>
      </div>
    </section>
  )
}
